import { render, staticRenderFns } from "./stationVideo.vue?vue&type=template&id=7fa48fbc&scoped=true"
import script from "./stationVideo.vue?vue&type=script&lang=js"
export * from "./stationVideo.vue?vue&type=script&lang=js"
import style0 from "./stationVideo.vue?vue&type=style&index=0&id=7fa48fbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa48fbc",
  null
  
)

export default component.exports